module.exports = __webpack_public_path__ + "media/images/ArdianlogoBW-5ad2c701.png";